type Flags = {
  [key: string]: {
    variation: string | null;
    rule: string | null;
  };
};

export const createOptimizelyEvent = (flags: Flags) => {
  const variantString = Object.entries(flags)
    .filter(([, flag]) => flag.variation && flag.rule)
    .map(([key, flag]) => `${key}_${flag.variation}_${flag.rule}`)
    .join(',');

  return {
    eventInfo: {
      event: 'optimizely_feature_decision',
      optimizely: {
        fxp_variant_string: variantString,
        enabled: true,
      },
      'gtm.uniqueEventId': 4,
    },
    eventOptions: {
      debugMessage: 'GA4 Data Layer Event (Optimizely)',
    },
  };
};
